(() => {
  const panel = document.querySelector('#bae-cookie-panel');
  if (!panel) return;
  let privacy;
  function open() {
    if (document.querySelector("#shopify-pc__banner")?.getClientRects().length) return;
    panel.hidden = false;
    if (privacy) {
      const state = privacy.currentVisitorConsent();
      panel.querySelectorAll('[data-consent]').forEach(input => input.checked = state[input.dataset.consent] === 'yes');
    }
  }
  document.querySelectorAll('[data-bae-cookie-open]').forEach(button => button.addEventListener('click', open));
  panel.querySelectorAll('[data-consent-action]').forEach(button => button.addEventListener('click', () => {
    const action = button.dataset.consentAction;
    if (action === 'configure') { panel.querySelector('.bae-cookie-options').hidden = false; return; }
    if (!privacy) { panel.querySelector('[data-consent-error]').hidden = false; return; }
    const decision = {};
    ['preferences', 'analytics', 'marketing'].forEach(key => {
      decision[key] = action === 'save' ? panel.querySelector('[data-consent="' + key + '"]').checked : action === 'accept';
    });
    panel.querySelectorAll('button').forEach(b => b.disabled = true);
    const timeout = setTimeout(() => { panel.querySelectorAll('button').forEach(b => b.disabled = false); panel.querySelector('[data-consent-error]').hidden = false; }, 8000);
    try {
      privacy.setTrackingConsent(decision, () => {
        clearTimeout(timeout);
        panel.querySelectorAll('button').forEach(b => b.disabled = false);
        panel.querySelector('[data-consent-error]').hidden = true;
        panel.hidden = true;
      });
    } catch (error) { clearTimeout(timeout); panel.querySelectorAll('button').forEach(b => b.disabled = false); panel.querySelector('[data-consent-error]').hidden = false; }
  }));
  let attempts = 0;
  function init() {
    if (window.Shopify && Shopify.customerPrivacy) { ready(); return; }
    if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
      Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error && Shopify.customerPrivacy) ready(); });
    } else if (++attempts < 20) setTimeout(init, 250);
  }
  function ready() {
    privacy = Shopify.customerPrivacy;
    // Shopify renders the initial consent banner; this panel is opened only from the footer.
  }
  document.addEventListener('visitorConsentCollected', () => { if (privacy) panel.hidden = true; });
  init();
})();

